{
  "login": {
    "title": "Sign In",
    "subtitle": "Welcome back to Sigma08",
    "email": "Email Address",
    "password": "Password",
    "rememberMe": "Remember me",
    "forgotPassword": "Forgot password?",
    "submit": "Sign In",
    "noAccount": "Don't have an account?",
    "signUp": "Sign up",
    "or": "Or continue with",
    "google": "Google",
    "microsoft": "Microsoft"
  },
  "signup": {
    "title": "Create Account",
    "subtitle": "Start your learning journey",
    "firstName": "First Name",
    "lastName": "Last Name",
    "email": "Email Address",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "role": "I am a",
    "roles": {
      "teacher": "Teacher",
      "parent": "Parent",
      "student": "Student"
    },
    "terms": "I agree to the Terms of Service and Privacy Policy",
    "submit": "Create Account",
    "hasAccount": "Already have an account?",
    "signIn": "Sign in"
  },
  "forgotPassword": {
    "title": "Reset Password",
    "subtitle": "Enter your email to receive reset instructions",
    "email": "Email Address",
    "submit": "Send Reset Link",
    "backToLogin": "Back to sign in",
    "success": "Check your email for reset instructions"
  },
  "resetPassword": {
    "title": "Set New Password",
    "subtitle": "Choose a strong password for your account",
    "password": "New Password",
    "confirmPassword": "Confirm Password",
    "submit": "Reset Password",
    "success": "Password reset successfully"
  },
  "logout": {
    "title": "Sign Out",
    "message": "Are you sure you want to sign out?",
    "confirm": "Sign Out",
    "cancel": "Cancel"
  }
}
